export const blogArticlePendingReducer = state => {
  state.content.isLoading = true;
};

export const blogArticleRejectedReducer = (state, action) => {
  state.content.isLoading = false;
  state.content.isError = action.payload;
  state.content.isDataLoaded = false;
};

export const blogArticleFulfilledReducer = (state, action) => {
  state.content.data = action.payload;
  state.content.slug = action.payload.slug;

  state.content.isDataLoaded = true;
  state.content.isLoading = false;
};
